import React from 'react';

class ApiResponse extends React.Component {
	
	/*
		props
			response
			defaultMessage
			mainMessageStyle
			additionalMessageStyle
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let message = this.props.response.message;
		if( ! message )
			message = this.props.defaultMessage;
		if( ! message )
			message = '';			
		let divMessageStyle = Object.assign( 
			{
				fontSize: '14pt',
				marginLeft: 'auto',
				marginRight: 'auto',
				marginTop: '10px',
				marginBottom: '10px',
				textAlign: 'center',
				padding: '5px'
			}, this.props.mainMessageStyle);

		let divAdditionalMessage = null;
		if( this.props.response.log ) {
			let divAdditionalMessageStyle = Object.assign( 
				{
					marginLeft: 'auto',
					marginRight: 'auto',
					marginBottom: '30px',
					width: '95%'
				}, this.props.additionalMessageStyle);
			divAdditionalMessage = (
				<div style={divAdditionalMessageStyle}>
					<textarea style={{width: '100%'}} rows="8" readOnly={true}>
						{this.props.response.log}
					</textarea>
				</div>		
			);
		}
		
		return (
			<div>
				<div style={divMessageStyle} dangerouslySetInnerHTML={{__html: message}} />
				{divAdditionalMessage}
			</div>
		);
	}
}

export default ApiResponse;
